<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px"
        v-loading="loading">
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item prop="title" label="标题">
             {{ formData.title||'--' }}
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item prop="description" label="说明">
              {{ formData.description||'--' }}

            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap" v-if="$attachmentFiles(formData.fileList).length>0">

                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

              </div>
              <div style="color:#999" v-else>暂无</div>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'fireLedgerDetail',

  data () {
    return {
      formData: {

        title: '',
        description: '',
        fileList: []
      },

      loading: false

    }
  },
  created () {
    if (this.ledgerId) {
      this.loadData()
    }
  },
  computed: {
    ledgerId () {
      return this.$route.query.ledgerId
    },

    fileImgUrl() {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.fireLedger.selectPaFireLedgerByLedgerId, {
          params: { ledgerId: this.ledgerId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
